module.exports = __webpack_public_path__ + "static/media/9.57f84232.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/9.png
// module id = 924
// module chunks = 0